import { connect } from 'react-redux';
import App from '../routes/App';
import { checkLoggedIn, onLoggedIn } from '../utils/ProfileHelpers'; // Remove this when fully converted
import { setAction } from './../redux/actions/app'; // Remove this when fully converted
import { updateChartCountAction } from './../redux/actions/profile'; // Remove this when fully converted

const mapStateToProps = (state) => {
  return {
    paths: state.app.paths || {},
    loading: state.app.loading,
    error: state.app.error,
    teams: state.profile.teams,
    subscription: state.profile.subscription,
    team: state.profile.team,
    divisions: state.profile.divisions,
    division: state.profile.division,
    messages: state.profile.messages || [],
    announcements: state.profile.announcements,
    billingPermissions: state.profile.billingPermissions,
    user: state.profile.user,
    unreadMessages: state.profile.unreadMessages,
    permissions: state.profile.permissions,
    isPaidPlanModalOpen: state.app.isPaidPlanModalOpen,
    wizardLoadingText: state.layoutEditorPage.wizardLoadingText,
    onLoggedIn: onLoggedIn,
    profile: state.profile,
    checkLoggedIn: checkLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => ({
  set: (params) => dispatch(setAction(params)),
  closePaidPlan: () => dispatch(setAction({ isPaidPlanModalOpen: false })),
  updateChartCount: () => dispatch(updateChartCountAction()),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(App);
